<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 col-md-12 pl-0 pr-0 mt-3">
				<div class="col-12 p-0 bg-white rounded-top-cus cus-box-shadow z-index-1">
					<div class="col-12 p-0 d-flex pt-3 pl-3 pl-md-4">
						<div class="col-12 p-0">
							<div class="row">
								<div class="col-6 col-md-6 font-size-sm-11">
									<p>Summary Saldo Digital</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 p-0 bg-white rounded-bot-cus cus-box-shadow">
					<div class="col-12 p-0 p-3 font-size-sm-10 font-size-10 d-flex">
						<div class="col-3">
							Total Pemasukan : <b>{{ summary.in }} BV</b>
						</div>
						<div class="col-3">
							Total Pengeluaran : <b>{{ summary.out }} BV</b>
						</div>
						<div class="col-3">
							Total Saldo : <b>{{ summary.saldo }} BV</b>
						</div>
						<div class="col-3">
							Total Expired : <b>{{ summary.expired }} BV</b>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 mt-3 font-size-sm-10 font-size-10 d-flex">
			<div class="col-3 bg-white rounded-cus p-3 mr-2 cursor-pointer box-serial" :class="currentType == '1' ? 'active' : '' " @click="pilihSerial(1)">
				<div>Pemasukan</div>
			</div>
			<div class="col-3 bg-white rounded-cus p-3 mr-2 cursor-pointer box-serial" :class="currentType == '2' ? 'active' : '' " @click="pilihSerial(2)">
				<div>Pengeluaran</div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 mt-3 font-size-sm-10 font-size-10 d-flex">
			<div class="col-12 bg-white rounded-cus p-3 mr-2 box-serial" v-if="listStockResultsDigital.length > 0">
				<div class="table-responsive">
					<table class="table mb-0 font-size-sm-9 font-size-10">
						<thead class="">
							<tr>
								<td>Kode Transaksi</td>
								<td class="text-center">Jumlah (BV)</td>
								<td class="text-center">Tanggal Transaksi</td>
								<td class="text-center" v-if="tab == '1'">Tanggal Expired</td>
								<td class="text-left" v-if="tab == '2'">Catatan</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(serial) in listStockResultsDigital" :key="serial.stock_serial_digital_id">
								<td>{{ serial.stock_serial_digital_trans_code }}</td>
								<td class="text-center" v-if="tab == '1'">{{ serial.stock_serial_digital_in }}</td>
								<td class="text-center" v-if="tab == '2'">{{ serial.stock_serial_digital_out }}</td>
								<td class="text-center">{{ serial.stock_serial_digital_created_datetime | tanggaljam }}</td>
								<td class="text-center" v-if="tab == '1'">{{ serial.stock_serial_digital_expired_date | toTanggal }}</td>
								<td class="text-left" v-if="tab == '2'">{{ serial.stock_serial_digital_note }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'paginationSerialDigital' @gotoPage="gotoPage($event)"  @refresh="refresh($event)"></i-pagination>
			</div>
			<div class="col-12 bg-white rounded-cus p-3 mr-2 box-serial" v-else>
				<div class="col-12 text-center">
					<div class="col-6 col-md-3 ml-auto mr-auto">
						<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
					</div>
					<div class="font-size-11 pt-1">Data tidak tersedia!</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import IPagination from '@/components/IPagination.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
	components: {
		IPagination
	},
	name: 'StockProduct',
	data() {
		return {
			currentDate : new Date().toLocaleString(),
			pilihanSerial : '',
			tanggalAwal:'',
			tanggalAkhir:'',
			tanggalAwalTerjual:'',
			tanggalAkhirTerjual:'',
			tanggalAwalKadaluarsa:'',
			tanggalAkhirKadaluarsa:'',
			params:[],
			tfilter: false,
			page: 1,
			limit : 8,
			status: [{
				text: "Tersedia",
				value: 0
			}, {
				text: "Kadaluarsa",
				value: 1
			}, {
				text: "Terjual",
				value: 2
			}],
			serialDigitalFilter:{
				value:'1',
				comparison:'=',
				type:'string',
				field:'stock_serial_digital_type',
			},
			currentType: '1',
			tab: '1',
			summary: {
				in: 0,
				out: 0,
				saldo: 0,
				expired: 0,
			},
		}
	},
	methods: {
		...mapActions('inventoryListDigital', ['getStock', 'getDataStockByDate', 'getDetailStock', 'getListSerialDigital', 'getDataStockSummarySerialDigital']),

		gotoPage(val) {
			this.page  = val
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter, ...this.params]}))
		},
		refresh(val) {
			this.page  = val
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter, ...this.params]}))
		},
		changeLimit(val) {
			this.page = 1
			this.limit  = val
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter, ...this.params]}))
		},
		toggleFilter() {
			if ( !this.tfilter ) {
				this.tfilter = true;
			} else {
				this.tfilter = false;
			}
		},
		reset() {
			this.pilihanSerial = ''
			this.tanggalAwal = ''
			this.tanggalAkhir = ''
			this.tanggalAwalTerjual = ''
			this.tanggalAkhirTerjual = ''
			this.tanggalAwalKadaluarsa = ''
			this.tanggalAkhirKadaluarsa = ''
			this.tanggalPembelian.value = ''
			this.tanggalTerjual.value = ''
			this.page  = 1
			this.limit = 8
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter]}))
		},
		cari() {
			this.params = []
			this.page = 1
			this.limit = 8
			if(!this.tanggalAkhir) {
				this.tanggalAkhir = this.tanggalAwal
			}
			if(this.tanggalAwal && this.tanggalAkhir) {
				this.tanggalPembelian.value = moment(this.tanggalAwal).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhir).format('YYYY-MM-DD')
				this.params.push(this.tanggalPembelian)
			}

			if(!this.tanggalAkhirTerjual) {
				this.tanggalAkhirTerjual = this.tanggalAwalTerjual
			}
			if(this.tanggalAwalTerjual && this.tanggalAkhirTerjual) {
				this.tanggalTerjual.value = moment(this.tanggalAwalTerjual).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirTerjual).format('YYYY-MM-DD')
				this.params.push(this.tanggalTerjual)
			}

			if(!this.tanggalAkhirKadaluarsa) {
				this.tanggalAkhirKadaluarsa = this.tanggalAwalKadaluarsa
			}
			if(this.tanggalAwalKadaluarsa && this.tanggalAkhirKadaluarsa) {
				this.tanggalKadaluarsa.value = moment(this.tanggalAwalKadaluarsa).format('YYYY-MM-DD')+"::"+moment(this.tanggalAkhirKadaluarsa)
				this.params.push(this.tanggalKadaluarsa)
			}

			if(this.pilihanSerial) {

				if(this.pilihanSerial.value == 0) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '>'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial.value == 1) {
					this.statusSerial.value = '0'
					this.statusSerialExpired.comparison = '<'
					this.statusSerialExpired.value = moment(this.currentDate).format('YYYY-MM-DD')
					this.params.push(this.statusSerial)
					this.params.push(this.statusSerialExpired)
				} else if(this.pilihanSerial.value == 2) {
					this.statusSerial.value = '1'
					this.params.push(this.statusSerial)
				} else {
					this.statusSerial.value = ''
				}
			}
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter, ...this.params]}))
		},
		pilihSerial (type) {
			this.getDataStockSummarySerialDigital().then(() => {
				this.summary = this.stockSerialDigital
			})
			
			this.currentType = type
			this.serialDigitalFilter.value = type

			this.page = 1
			this.params = []
			this.limit = 8
			this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter]})).then(() => { this.tab = type })
		},
	},
	computed: {
		...mapState('inventoryListDigital', ['dataStock', 'stockSerialDigital', 'paginationSerialDigital', 'listStockResultsDigital']),
		...mapState('auth', ['userData']),
		...mapGetters('auth', ['isAuth']),

		maxDate(){
			var date = new Date().toISOString()
			if (this.tanggalAkhir) {
				date = new Date(this.tanggalAkhir).toISOString()
			}
			return date
		},
		maxDateTerjual(){
			var date = new Date().toISOString()
			if (this.tanggalAkhirTerjual) {
				date = new Date(this.tanggalAkhirTerjual).toISOString()
			}
			return date
		}
	},
	created () {
		this.$store.dispatch('setPageTitle', 'Stok Serial');
		this.getDataStockSummarySerialDigital().then(() => {
			this.summary = this.stockSerialDigital
		})
		this.getListSerialDigital(this.queryString({limit:this.limit, page: this.page, params:[this.serialDigitalFilter]}))
	}
};
</script>
